import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LenisProvider } from "@/lib/lenis";
import { AuthProvider } from "@/lib/auth";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Brands } from "@/components/Brands";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Stats } from "@/components/Stats";
import { WhyIndia } from "@/components/WhyIndia";
import { Process } from "@/components/Process";
import { Calculator } from "@/components/Calculator";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BrandKit from "@/pages/BrandKit";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";

const Landing = () => (
  <LenisProvider>
    <div className="grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Brands />
        <Manifesto />
        <Services />
        <Stats />
        <WhyIndia />
        <Process />
        <Calculator />
        <Contact />
      </main>
      <Footer />
    </div>
  </LenisProvider>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/brand" element={<BrandKit />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:jobId" element={<JobDetail />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#111736", border: "1px solid rgba(255,255,255,.12)", color: "#fff" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
